import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useContactDialog } from "../context/ContactDialogContext";

const navLinks = [
  { to: "/", label: "Hem", testid: "nav-home-link" },
  { to: "/funktioner", label: "Funktioner", testid: "nav-features-link" },
  { to: "/priser", label: "Pris", testid: "nav-pricing-link" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { openDialog } = useContactDialog();

  const handleContactClick = (e) => {
    e.preventDefault();
    setOpen(false);
    openDialog(null);
  };

  const handleDemoClick = (e) => {
    e.preventDefault();
    setOpen(false);
    openDialog("demo");
  };

  return (
    <header className="glass-nav sticky top-0 z-50" data-testid="site-navbar">
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-3 group"
          data-testid="nav-logo-link"
          onClick={() => setOpen(false)}
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[#d4af37]/40 text-[#d4af37] font-serif text-xl">
            O
          </span>
          <span className="font-serif text-2xl tracking-tight text-white">
            Orkester<span className="gold-text">admin</span>
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-10">
          {navLinks.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                end={l.to === "/"}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `nav-link text-sm tracking-wide uppercase ${isActive ? "active" : ""}`
                }
              >
                {l.label}
              </NavLink>
            </li>
          ))}
          <li>
            <button
              type="button"
              onClick={handleContactClick}
              data-testid="nav-contact-button"
              className="nav-link text-sm tracking-wide uppercase bg-transparent"
            >
              Kontakt
            </button>
          </li>
        </ul>

        <div className="hidden md:block">
          <button
            type="button"
            onClick={handleDemoClick}
            data-testid="nav-cta-demo-button"
            className="btn-gold inline-flex items-center px-5 py-2.5 rounded-full text-sm"
          >
            Boka Demo
          </button>
        </div>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          aria-label="Meny"
          data-testid="nav-mobile-toggle-button"
        >
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#0a1128]/95" data-testid="nav-mobile-menu">
          <ul className="px-6 py-6 space-y-4">
            {navLinks.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  end={l.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`${l.testid}-mobile`}
                  className={({ isActive }) =>
                    `block text-base ${isActive ? "text-white" : "text-white/70"}`
                  }
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
            <li>
              <button
                type="button"
                onClick={handleContactClick}
                data-testid="nav-contact-button-mobile"
                className="block text-base text-white/70 bg-transparent"
              >
                Kontakt
              </button>
            </li>
            <li>
              <button
                type="button"
                onClick={handleDemoClick}
                data-testid="nav-cta-demo-button-mobile"
                className="btn-gold inline-flex items-center px-5 py-2.5 rounded-full text-sm"
              >
                Boka Demo
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
